import React from 'react';

import ActivityIndicator from '~/UI/ActivityIndicator/ActivityIndicator';
import Loadable from 'react-loadable';

const LoadingSpinner: React.FC<Record<never, never>> = () => <ActivityIndicator />;

const LoadableERPBarChart = Loadable({
	loader: () => import(/* webpackChunkName: "erp-bar",  webpackPrefetch: true */ './ERPBarChart'),
	loading: LoadingSpinner,
});

LoadableERPBarChart.displayName = 'MedicinalBrandsAnalytics.ERPChart.LoadableERPBarChart';

export default LoadableERPBarChart;
